import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[appImagefull]',
    standalone: false
})
export class ImagefullDirective {
	@Input('img') img;

	divW: any;
	divH: any;
	divAspect: any;
	backgroundColor = '#000000';

	checksize() {
		this.divW = this.el.nativeElement.clientWidth;
		this.divH = this.el.nativeElement.clientHeight;
		this.divAspect = this.divW / this.divH;

		var realHeight = this.el.nativeElement.children[0].naturalHeight;
		var realWidth = this.el.nativeElement.children[0].naturalWidth;

		let calculated = this.calculateAspectRatioFit(realWidth, realHeight, this.divW, this.divH);
		this.el.nativeElement.children[0].style.height = `${calculated.height ? calculated.height : 0}px`;
		this.el.nativeElement.children[0].style.width = `${calculated.width ? calculated.width : 0}px`;
		this.el.nativeElement.children[0].style.margin = `0 auto`;
		this.el.nativeElement.children[0].style.display = `block`;
	}

	calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
		var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
		return { width: srcWidth * ratio, height: srcHeight * ratio };
	}

	ngAfterContentChecked() {
		this.checksize();
	}

	ngOnInit() {
		this.el.nativeElement.style.backgroundColor = this.backgroundColor;
		this.el.nativeElement.style.display = 'flex';
		this.el.nativeElement.style.height = '100vh';
		this.el.nativeElement.style.alignItems = 'center';
		this.el.nativeElement.style.justifyContent = 'center';
		this.checksize()
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.img) {
			this.checksize();
		}
	}

	constructor(private el: ElementRef) {

	}
}